// extracted by mini-css-extract-plugin
module.exports = {"heading":"H1Tag_heading__tW0Do"};